module.exports = __webpack_public_path__ + "img/choose-up-Up Social Respect-disabled.cc7d484a.png";